export default __webpack_public_path__ + "static/media/WhiteCheck.dc31740d.svg";